import { JsonMappable } from '../data/json-mappable.js'
import type {
	RoutePathType,
	ModuleIdType,
	BusinessObjectIdType,
	TsCodeType,
} from '../types.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
	jsonMapProperty,
} from '@sumbricht/json-class-serializer'
import { BoReference } from './bo-reference.js'
import { assignCommonProperties } from '../util/data/assign-common-properties.js'

@jsonClass('ScreenRoute')
export class ScreenRoute extends BoReference {
	@jsonProperty(String)
	path?: RoutePathType

	constructor(init?: Partial<ScreenRoute>) {
		super()
		assignCommonProperties(this, init)
	}

	getRouteTsDefinition(): TsCodeType {
		const canDeactivateStr = 'canDeactivate: [FormCanDeactivate]'
		if (this.path == '**') {
			return `{ path: '${this.path}', component: ${this.moduleId}__${this.boId}, ${canDeactivateStr} }`
		}
		return `{ path: '${this.path}', children: [{ path: '**', component: ${this.moduleId}__${this.boId}, ${canDeactivateStr} }] }`
	}
}
